/* eslint-disable */
import { phoneSources } from '@ringcentral-integration/commons/enums/phoneSources';
export default {
  [phoneSources.account]: 'Account',
  [phoneSources.contact]: 'Contactpersoon',
  [phoneSources.rcContact]: '{brand}',
  [phoneSources.lead]: 'Lead',
  [phoneSources.opportunity]: 'Kans',
  [phoneSources.systemUser]: 'Systeemgebruiker',
};

// @key: @#@"[phoneSources.account]"@#@ @source: @#@"Account"@#@
// @key: @#@"[phoneSources.contact]"@#@ @source: @#@"Contact"@#@
// @key: @#@"[phoneSources.rcContact]"@#@ @source: @#@"{brand}"@#@
// @key: @#@"[phoneSources.lead]"@#@ @source: @#@"Lead"@#@
// @key: @#@"[phoneSources.opportunity]"@#@ @source: @#@"Opportunity"@#@
// @key: @#@"[phoneSources.systemUser]"@#@ @source: @#@"System User"@#@
